"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.epsRead = epsRead;
exports.epsUpdate = epsUpdate;
const axios_1 = __importDefault(require("axios"));
function epsUpdate(epsData, accessToken, aibaEpsConfig) {
    return __awaiter(this, void 0, void 0, function* () {
        const EPS_API_URL = `${aibaEpsConfig['url']}`;
        console.log('[services.eps-service.epsUpdate()]');
        try {
            const epsUpdate = yield (0, axios_1.default)({
                method: 'POST',
                responseType: 'json',
                url: `${EPS_API_URL}/update`,
                headers: {
                    'x-api-key': aibaEpsConfig['apiKey'],
                    'Authorization': `Bearer ${accessToken}`,
                    'Content-Type': 'application/json',
                },
                data: epsData,
            });
            return epsUpdate;
        }
        catch (error) {
            throw error;
        }
    });
}
function epsRead(epsData, accessToken, aibaEpsConfig) {
    return __awaiter(this, void 0, void 0, function* () {
        const EPS_API_URL = `${aibaEpsConfig['url']}`;
        console.log('[services.eps-service.epsRead()]');
        try {
            const epsRead = yield (0, axios_1.default)({
                method: 'POST',
                responseType: 'json',
                url: `${EPS_API_URL}/read`,
                headers: {
                    'x-api-key': aibaEpsConfig['apiKey'],
                    'Authorization': `Bearer ${accessToken}`,
                    'Content-Type': 'application/json',
                },
                data: epsData,
            });
            return epsRead.data;
        }
        catch (error) {
            throw error;
        }
    });
}
